<template>
  <div>
    <template v-if="showHeader && material">
      <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
      <v-row class="mt-10">
        <v-col class="d-flex pt-0">
          <img
              alt="resource center"
            src="../../assets/icons/sorts/resource_center.png"
            class="tcdc-resource-center-layout-icon mr-4"
          />
          <span class="text-tcdc-green bold header text-uppercase">resource center</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span class="text-tcdc-green header bold text-uppercase">{{material[`title_${lang}`]}}</span>
        </v-col>
      </v-row>
    </template>
    <v-row class="my-8">
      <v-col v-if="material && material[`description_${lang}`]">
        <div class="bold header grey--text vhtml" v-html="material[`description_${lang}`]">
        </div>
      </v-col>
    </v-row>
    <v-row class="mb-8" v-if="material && material.attached_website">
      <v-col>
        <a @click="goToWebsite(material.attached_website)">
          <GreenButton label="visit website" />
        </a>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="material && material.slide_images.length > 0">
        <ImageCarousel :images="material.slide_images"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import ImageCarousel from "../../components/carousels/ImageCarousel";
import { mapState } from "vuex";
import {BreadcrumbUtil} from "@/util/BreadcrumbUtil";

export default {
  components: {
    GreenButton,
    ImageCarousel
  },
  props: {
    showHeader: {
      type: Boolean,
      default: false
    }
  },
  async created() {
    this.items = BreadcrumbUtil.setServiceItem(
        this.items,
        this.branchId,
        this.branchName,
        this.allBranches,
        this.lang
    )
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      allBranches: state => state.Branch.branches,
      branchId: state => state.Branch.branch_id,
      lang: state => state.Branch.lang,
      material : state => {
        if (state.ServiceMenu.resource_centers.material) {
          return state.ServiceMenu.resource_centers.material
        }
      }
    }),
    branchChanged: function () {
      return this.branchName;
    }
  },
  watch: {
    branchChanged: function() {
      this.items = BreadcrumbUtil.setServiceItem(
          this.items,
          this.branchId,
          this.branchChanged,
          this.allBranches,
          this.lang
      )
    }
  },
  methods:{
    goToWebsite(url){
      if(url){
        window.open(url,'_blank')
      }
    }
  },
  data: () => ({
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: false,
        to: "/home/:branch"
      },
      {
        text: "SERVICE",
        disabled: false,
        to: "/:branch/service"
      },
      {
        text: "RESOURCE CENTER",
        href: "/:branch/service/resource-center"
      },
      {
        text: "MATERIAL",
        disabled: true,
      }
    ]
  })
};
</script>

<style>
</style>
